<template>
  <section class="px-4">
    <section class="mt-4 flex items-center">
      <div class="m-6 shadow-lg w-1/2 p-4">
        <h1 class="text-2xl" v-text="data.cuti"></h1>
        <p class="text-gray-400">Cuti tersisa</p>
      </div>
      <div class="m-6 w-1/2 p-4">
        <Input label="Input Saldo Cuti:" input_class="md:w-4/6 w-full mt-1" class="mb-2.5" :value="cutiInput"
          @change="cutiInput = $event" type="number" step="1"/>
      </div>
    </section>
    <div class="flex justify-end w-full my-4">
      <Button class="bg-primary text-white w-24 text-sm rounded py-2" @click="handleSaveCuti" :disabled="loading">
        Save
      </Button>
    </div>
  </section>
</template>

<script>
import Input from "./Input.vue";
import Button from "./Button.vue";
import { EditCutiEmployementAPI } from "@/actions/employment";
import { useToast } from "vue-toastification";

export default {
  name: "CutiDetail",
  // props: { tab_active: String },
  components: { Input, Button, },
  props: {
    cutiDetail: Object,
    handleDetailEmployment: Function,
  },
  data() {
    return {
      loading: false,
      cutiInput: "",
      data: {
        cuti: this.cutiDetail.amount ?? 0,
      }
    };
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  methods: {
    showMessageStatus(response) {
      if (response.status === 200) {
        this.handleDetailEmployment();
        this.toast.success(response?.data?.message);
      } else {
        if (response.data.message) {
          this.toast.error(response?.data?.message);
        }
      }
    },
    async handleSaveCuti() {
      this.loading = true;
      const { id } = this.$route.params;
      const response = await EditCutiEmployementAPI(id, { amount: this.cutiInput });
      if (response.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      } else if (response.status === 200) {
        this.data.cuti = this.cutiInput;
        this.cutiInput = "";
      }
      this.showMessageStatus(response);
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
